export const enum BuyPath {
  EmergingLayer = 'HSA_PB_EMERGINGLAYER',
  CompleteYourJourney = 'HSA_PB_YOURJOURNEY',
  PromoGift = 'HSA_PB_GIFT',
  Popunder = 'HSA_PB_POPUNDER',
  PostbookingDeals = 'HSA_PB_DEALS',
  HomeDeals = 'HSA_HOME_DEALS',
  PostbookingHotelBanner = 'HSA_PB_BANNER',
  FlightsXSellingPage = 'HSA_FLIGHT_CONFIRMATION',
  PostbookingDealsGridMobile = 'HSA_PB_MOBILE_DEALS',
  FlightsResultsHotelSuggestions = 'HSA_FL_RESULT_HOTEL_SUGGESTIONS',
  AccommodationUserMoment = 'HSA_PB_JOKER',
  PostbookingMapHotelSearch = 'HSA_PB_MAP_HOTEL_SEARCH',
  RecentHotelSearches = 'ACCH_ACCOMMODATION_SEARCH_HISTORY_WEB',
  HomeCompleteYourJourney = 'HSA_HOME_COMPLETE_YOUR_JOURNEY',
  FlightSummary = 'HSA_FLIGHT_SUMMARY',
  HsaAccommodationRecommendationWeb = 'HSA_ACCOMMODATION_RECOMMENDATION_WEB',
}

export const buyPathMicroStrategyMap: Partial<Record<BuyPath, number>> = {
  [BuyPath.HsaAccommodationRecommendationWeb]: 7292,
} as const;
